<template>
  <svg id="icon-user" width="20" height="20" viewBox="0 0 20 20">
    <g fill="none" fill-rule="evenodd">
      <path stroke="currentColor" d="M-15.5-12.5h554v512h-554z"/>
      <path d="M6.071 6.929a3.929 3.929 0 1 1 7.858 0 3.929 3.929 0 0 1-7.858 0zm9.429 9.339c0 .468-11 .468-11 0v-1.696c0-2.34 4.708-4.239 5.5-4.239.837 0 5.5 1.898 5.5 4.24v1.695z" fill="currentColor" fill-rule="nonzero"/>
    </g>
  </svg>
</template>
